import { CalendarClock } from "lucide-react";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";
import { EntryValueChip } from "./EntryValueChip";
import { formatEntryDate } from "./formatEntryDate";

export interface DateTimePickerEntryValueProps extends Omit<BaseEntryValueProps, "value"> {
    value: string | null;
}

export function DateTimePickerEntryValue({
    value,
    inputLabel,
    size,
    className,
    ...props
}: DateTimePickerEntryValueProps) {
    const date = formatEntryDate(value, "D MMM YYYY");
    const time = formatEntryDate(value, "HH:mm");
    return (
        <BaseEntryValue inputLabel={inputLabel} size={size} className={className} {...props}>
            <EntryValueChip icon={date ? CalendarClock : undefined} size={size}>
                {date ? (
                    <>
                        {date}
                        <span className="font-normal text-slate-500 dark:text-slate-400">at {time}</span>
                    </>
                ) : (
                    "None"
                )}
            </EntryValueChip>
        </BaseEntryValue>
    );
}
